import {
  type DonutChartProps,
  DonutChart as MantineDonutChart,
} from "@mantine/charts";

const DonutChart = ({ ...props }: DonutChartProps) => {
  return (
    <MantineDonutChart
      classNames={{
        root: "h-full w-full outline-none focus:outline-none",
        tooltip:
          "overflow-hidden rounded-lg bg-white/30 shadow shadow backdrop-blur-md",
        tooltipItemColor: "h-3 w-4 rounded-full",
        tooltipItemBody:
          "flex items-center gap-2 text-sm bg-white/40 px-4 py-2",
        tooltipItemData: "w-full py-2 text-center font-bold text-2xl",
      }}
      size={275}
      strokeWidth={0}
      thickness={80}
      tooltipDataSource={"segment"}
      {...props}
    />
  );
};

export default DonutChart;
